import { loadProtobufSchemas, loadCustomSchemas } from '@/api/schema'

export default {
  methods: {
    getSchemaList(nodeID) {
      return new Promise((resolve, reject) => {
        Promise.allSettled([loadProtobufSchemas(nodeID), loadCustomSchemas(nodeID)])
          .then((res) => {
            const { data: protobufList } = res[0].value
            const { data: customList } = res[1].value
            const protobufRecords = protobufList.map((item) => {
              return {
                name: item,
                type: 'protobuf',
              }
            })
            const customRecords = customList.map((item) => {
              return {
                name: item,
                type: 'custom',
              }
            })
            const list = [...protobufRecords, ...customRecords]
            resolve(list)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
